import React, { useEffect, useRef, useState } from "react";
import "./AutoPIPVideo.css";

const AutoPIPVideo = ({
  videoId = "UVOp0YViG4g",
  autoplayDelay = 7000,
  muted = true,
}) => {
  const [mode, setMode] = useState("expanded");
  const timeoutRef = useRef(null);

  useEffect(() => {
    timeoutRef.current = setTimeout(() => {
      setMode("minimized");
    }, autoplayDelay);

    return () => clearTimeout(timeoutRef.current);
  }, [autoplayDelay]);

  const handleMinimize = () => {
    clearTimeout(timeoutRef.current);
    setMode("minimized");
  };

  const handleExpand = () => {
    setMode("expanded");
  };

  const handleClose = () => {
    clearTimeout(timeoutRef.current);
    setMode("closed");
  };

  if (mode === "closed") return null;

  const origin = encodeURIComponent(window.location.origin || "http://localhost:3000");
  const src = `https://www.youtube.com/embed/${videoId}?rel=0&showinfo=0&autoplay=1&mute=${muted ? 1 : 0}&playsinline=1&enablejsapi=1&origin=${origin}`;

  return (
    <>
      <div className={`apv-overlay ${mode === "expanded" ? "show" : "hide"}`}>
        <div className="apv-inner">
          <iframe
            title="intro-video"
            src={src}
            allow="autoplay; encrypted-media; picture-in-picture"
            referrerpolicy="strict-origin-when-cross-origin"
            allowFullScreen
          />
          <div className="apv-controls top-right">
            {/* visible label changed to "−" */}
            <button className="apv-btn" onClick={handleMinimize} aria-label="Minimize">−</button>
            {/* visible label changed to "✕" */}
            <button className="apv-btn" onClick={handleClose} aria-label="Close">✕</button>
          </div>
        </div>
      </div>

      <div className={`apv-mini ${mode === "minimized" ? "visible" : ""}`} role="dialog" aria-label="Mini video">
        <iframe
          title="mini-video"
          src={src}
          allow="autoplay; encrypted-media; picture-in-picture"
          referrerpolicy="strict-origin-when-cross-origin"
          allowFullScreen
        />
        <div className="apv-controls">
          <button className="apv-btn" onClick={handleExpand} aria-label="Expand">▢</button>
          <button className="apv-btn" onClick={handleClose} aria-label="Close">✕</button>
        </div>
      </div>
    </>
  );
};

export default AutoPIPVideo;